import { render } from "./EventsIcon.vue?vue&type=template&id=fa6069de"
import script from "./EventsIcon.vue?vue&type=script&lang=js"
export * from "./EventsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__